import { render } from "./FeederPrintLegend.vue?vue&type=template&id=751efc38&scoped=true"
import script from "./FeederPrintLegend.vue?vue&type=script&lang=js"
export * from "./FeederPrintLegend.vue?vue&type=script&lang=js"

import "./FeederPrintLegend.vue?vue&type=style&index=0&id=751efc38&lang=css"
import "./FeederPrintLegend.vue?vue&type=style&index=1&id=751efc38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-751efc38"

export default script